import { ListItemText, MenuItem, Select, SelectProps } from "@mui/material";
import { isArray } from "lodash";
import { TrailerType } from "../../../../graphql/generated";
import trailerTypeLabel from "../../../../utils/labels/trailerTypeLabel";
import { ConditionValueSelectorComponentProps } from "../ConditionForm";
import { testIds } from "./TrailerTypeSelect.testIds";

const TrailerTypeSelect = ({
  value,
  onChange,
  ...otherProps
}: ConditionValueSelectorComponentProps & Pick<SelectProps<string>, "sx">) => {
  return (
    <Select
      data-testid={testIds.trailerTypeSelect}
      label="Trailer Type"
      size="small"
      multiple
      value={isArray(value) ? (value as TrailerType[]) : []}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      renderValue={(selected) =>
        selected.map((trailerType) => trailerTypeLabel(trailerType)).join(", ")
      }
      {...otherProps}
    >
      {Object.values(TrailerType).map((trailerType) => (
        <MenuItem data-testid={`${testIds.trailerTypeOption}-${trailerType}`} key={trailerType} value={trailerType}>
          <ListItemText primary={trailerTypeLabel(trailerType)} />
        </MenuItem>
      ))}
    </Select>
  );
};

export default TrailerTypeSelect;
